import * as React from 'react';
import {styled} from '@mui/material/styles';
import Tooltip, {tooltipClasses, TooltipProps} from '@mui/material/Tooltip';

const CustomTooltip = styled(({className, ...props}: TooltipProps) => (
    <Tooltip
        {...props}
        classes={{popper: className}}
        arrow
        enterTouchDelay={0}
        leaveTouchDelay={50000}
    />
))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'rgba(235, 233, 233, 0.95)',
        color: 'black',
        boxShadow: theme.shadows[1],
        fontSize: 15,
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: 'rgba(235, 233, 233, 0.95)',
    },
}));

export default CustomTooltip;
